import { render } from "./ClockIcon.vue?vue&type=template&id=4727e4fb&scoped=true"
import script from "./ClockIcon.vue?vue&type=script&lang=js"
export * from "./ClockIcon.vue?vue&type=script&lang=js"

import "./ClockIcon.vue?vue&type=style&index=0&id=4727e4fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4727e4fb"]])

export default __exports__